import styled from 'styled-components';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';

const StyledTextAreaField = styled.div`
  ${(props) => props.customStyles}
  ${(props) => props.defaultStyles}
`;

export default function TextArea({
  onChange,
  customStyles,
  label = '',
  type = 'text',
  name,
  value = '',
}) {
  const { whiteLabelSettings: { secondaryColourDarker } = {} } =
    useWhiteLabelSettings();

  const defaultStyles = `
    textarea:focus {
      border-color: ${secondaryColourDarker};
    }
    margin: .5rem 0;
    width: 100%;
  `;

  return (
    <StyledTextAreaField
      customStyles={customStyles}
      defaultStyles={defaultStyles}
    >
      <label className="text-gray-500 text-sm" htmlFor={name}>
        <textarea
          type={type}
          name={name}
          className={`
            w-full
            px-3
            py-1.5
            my-1
            h-48
            text-[15px]
            font-normal
            text-gray-700
            bg-white bg-clip-padding
            border border-solid border-gray-300
            rounded
            transition
            ease-in-out
            m-0
            focus:text-gray-700 focus:bg-white focus:outline-none`}
          value={value || ''}
          onChange={onChange}
          placeholder={label}
        />
      </label>
    </StyledTextAreaField>
  );
}
